<template>
    <div class="row g-4">
        <div class="col-12">
            <label for="inputName" class="form-label">Name <sup class="text-danger">*</sup></label>
            <input type="text" id="inputName" v-model="fields.name" class="form-control" :class="fields.errors.name ? 'is-invalid':''" placeholder="enter name"  autofocus autocomplete="new-name">
            <div v-if="fields.errors.name" class="invalid-feedback">
                {{ fields.errors.name }}
            </div>
        </div>
        <div class="col-lg-6">
            <label for="inputEmail" class="form-label">Email Address <sup class="text-danger">*</sup></label>
            <input id="inputEmail" type="email" inputmode="email" v-model="fields.email" class="form-control" :class="fields.errors.email ? 'is-invalid':''" placeholder="mail@example.com" autofocus autocomplete="new-email">
            <div v-if="fields.errors.email" class="invalid-feedback">
                {{ fields.errors.email }}
            </div>
        </div>
        <div class="col-lg-6">
            <label for="inputContact" class="form-label">Contact No. <sup class="text-danger">*</sup></label>
            <input type="tel" inputmode="numeric" class="with-6 form-control" :class="fields.errors.contact_no ? 'is-invalid':''" v-model="fields.contact_no" id="inputContact" placeholder="e.g. 601233456789" autocomplete="new-contact_no"  @input="fields.contact_no = $filters.validateNumberInput(fields.contact_no)">
            <div v-if="fields.errors.contact_no" class="invalid-feedback">
                {{ fields.errors.contact_no }}
            </div>
        </div>
        <div v-if="props.register" class="col-lg-6">
            <label for="inputPassword" class="form-label">Password <sup class="text-danger">*</sup></label>
            <div class="input-group">
                <input :type="showPassword ? 'text':'password'" v-model="fields.password" class="form-control" :class="fields.errors.password ? 'is-invalid':''" id="inputPassword" placeholder="enter password" autocomplete="new-password">
                <button type="button" class="input-group-text rounded-end" @click="showPassword = !showPassword">
                    <i class="fas fa-sm" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </button>
                <div v-if="fields.errors.password" class="invalid-feedback">
                    {{ fields.errors.password }}
                </div>
            </div>
        </div>
        <div v-if="props.register" class="col-lg-6">
            <label for="inputPasswordConfirm" class="form-label">Confirm Password <sup class="text-danger">*</sup></label>
            <input :type="showPassword ? 'text':'password'" v-model="fields.password_confirmation" class="form-control" :class="fields.errors.password_confirmation ? 'is-invalid':''" id="inputPasswordConfirm" placeholder="enter password" autocomplete="new-password-confirm">
        </div>
    </div>
</template>

<script setup>
    import { ref } from 'vue';

    const props = defineProps({ fields: Object, register: Boolean})
    const showPassword = ref(false);

</script>
